import styled from "styled-components";
import { Paper } from "@material-ui/core/";

export const TeamsMember = styled(Paper)`
  margin: 10px;
  padding: 10px;
  width: 20%;
  min-width: 220px;
  &:hover {
    background: #f8f8f8;
  }
`;
